import { CustomTable } from "@/components/Tables/CustomTable"
import { columns } from "@/pages/locations/Columns"
import Modal from "@/pages/locations/Model"
import { CrudProvider } from "@/context/crudContext"
import Breadcrumbs from "@/components/Breadcrumbs/Breadcrumbs"

export default function LocationList() {
  const breadcrumbs = [{ label: "Dashboard", url: "/pos/dashboard" }, { label: "Locations" }]

  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-card">
        <h5>Locations</h5>

        <Breadcrumbs breadcrumbs={breadcrumbs} />
      </div>

      <CrudProvider>
        <LocationTable />
      </CrudProvider>
    </>
  )
}

function LocationTable() {
  return (
    <>
      <CustomTable
        label="Locations"
        columns={columns}
        apiPath="location"
        view={false}
        showImport={true}
      />

      <Modal />
    </>
  )
}
